import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { GroupMember } from '@schoolbelle/api/group-member';

@Component({
  selector: 'member-status-badge',
  templateUrl: './member-status-badge.component.html',
  styleUrls: ['./member-status-badge.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MemberStatusBadgeComponent implements OnInit {
  @Input('isButton') isButton:boolean = false;
  @Input('member') member:GroupMember;

  constructor() { }

  ngOnInit() {
  }


  get status () {
    if (this.member) {
      // if (this.member.member_user_id && this.member.device_cnt === 0) return 'no-device';
      // else 
      if (this.member.member_utg_id) {
        return 'reachable';
      } 
      else if (this.member.member_user_id) {
        if (this.member.member_request_status === 1) return 'pending';
        else if (this.member.member_request_status === -1) return 'declined';
        else if (this.member.member_request_status === 0) return 'uninvited';
        else if (this.member.member_request_status === -2) return 'left';
      } 
      else if (this.member.member_phone_number) {
        return 'unregistered';
      }
    } else {
      return undefined;
    }
  }
  get noDevice ():boolean {
    if(this.member.device_cnt === 0) return true;
    return false;
  }
}
